export default __webpack_public_path__ + "static/media/gallery_05.212502a2.jpg";